import app from 'app';
// import _ from '#/lodash-extended';
import { isAssetCandidateForTranscribe } from 'v/Story/Timeline/api/transcription';
import { workPool } from '@wochitnpm/helpers';

const handlers = {
  setEnableVOSubtitles(store, mutation) {
    app.analytics('analytics:timeline:changedCC', {
      'Timeline Type': 'Time',
      'New State': mutation.payload,
    });
  },

  setTimelineZoom(store, mutation) {
    if ('rowDuration' in mutation.payload) {
      app.storyController.story.remoteStash.set(
        'rowDuration',
        mutation.payload.rowDuration
      );
    }
  },

  addSelectedAsset: function (store, mutation) {
    const { asset, isUserSelection, transcriptLanguageCode } = mutation.payload;
    // const assetUUID = asset.metadata.assetUUID;
    const now = Date.now();

    store.state.story.addSelectedAsset_timestamp = now;
    if (!asset.dateSelected) {
      // set date of selection only if absent
      app.Vue.set(asset, 'dateSelected', now);
    }
    app.Vue.set(asset, 'score', app.assetScore.EXCELLENT);
    workPool.job.trimVideoFragment.execute({ asset });
    workPool.job.createExternalAsset.execute({ asset });

    const story = app.storyController.story;
    if (!app.assetType.isDynamicProvider(asset)) {
      story.adjustVideoPoster_onAssetSelected(asset);
    }

    // const doppelgangers = _.filter(store.state.story.selectedAssets, (a) => {
    //   return a.metadata.assetUUID === assetUUID;
    // });
    const testForTranscript =
      isUserSelection &&
      // doppelgangers.length < 2 &&
      isAssetCandidateForTranscribe(asset);

    if (testForTranscript) {
      store.dispatch('FETCH_TRANSCRIPTION', {
        asset,
        transcribeSubType: app.transcribeSubType.VIDEO,
        how: workPool.job.transcriptions.HOW.READ,
        languageCode: transcriptLanguageCode,
      });
    }

    const testForScenes =
      isUserSelection &&
      app.assetType.isFRAGMENT(asset) &&
      !app.assetType.isSOCIALFRAGMENT(asset);

    if (testForScenes) {
      store.dispatch('FETCH_SCENES', {
        assetId: asset.metadata.assetUUID,
      });
    }
  },

  addSelectedVoiceOverSegment: function (store, mutation) {
    const { asset } = mutation.payload;
    const now = Date.now();
    store.state.story.addSelectedAsset_timestamp = now;

    if (!asset.dateSelected) {
      // set date of selection only if absent
      app.Vue.set(asset, 'dateSelected', now);
    }

    store.dispatch('FETCH_TRANSCRIPTION', {
      asset,
      transcribeSubType: app.transcribeSubType.NARRATION,
      how: workPool.job.transcriptions.HOW.CREATE,
    });

    workPool.job.audiowaveform.execute({
      asset,
      checkIfExists: false,
    });
  },

  removeSelectedAsset: function (store, mutation) {
    const { asset } = mutation.payload;
    const story = app.storyController.story;
    story.adjustVideoPoster_onAssetUnselected(asset);
  },
};

export default function StoryMutationPlugin(store) {
  const off = store.subscribe((mutation, state) => {
    const handler = handlers[mutation.type];
    if (typeof handler === 'function') {
      handler(store, mutation, state);
    }
  });
  store.state.story.pluginOffHandlers.add(off);
}
